import image1 from "../assets/graphicimg1.png";
import image2 from "../assets/graphicimg2.png";
import image3 from "../assets/graphicimg3.png";

export const graphicData = [
  {
    image: image1,
    review:
      "Simple logo design for youtube channel. And also the cover and the mockups created for better appearance.",
    name: "Gamers Hub",
    used: "Adobe Illustrator / Adobe Photoshop",
  },
  {
    image: image2,
    review:
      "Facebook post design for mobile phone shop. Modern and simple looking post design. Full detailed and better color choosing.",
    name: "Phone shop post",
    used: "Adobe Illustrator / Adobe Photoshop",
  },
  {
    image: image3,
    review:
      " Facebook post design for Clothings. Modern and simple looking post design for selling shirts. Full detailed and better color choosing.",
    name: "Shirt Post",
    used: "Adobe Illustrator / Adobe Photoshop",
  },
];
